<template>
    <div class="legend bordered">
        <h5 class="mx-1 pb-2 border-bottom">Legend</h5>
        <div class="my-2 pb-2 border-bottom" v-for="obj in data.filter(x => x.layerKey == 'marker')" :key="obj.title">
            <h6>{{obj.title}}</h6>
            <img src="~leaflet/dist/images/marker-icon-2x.png" style="height: 26px; width: 18px; float: left; margin-right: 1px;"
                v-if="obj.title =='Agents'" />
            <img src="@/assets/img/icons/ico-house-green.svg" style="height: 28px; width: 28px; float: left;" v-else />
            <div class="my-cluster small-cluster-colors" style="float:left;">
                <div>
                    <span></span>
                </div>
            </div>
            <div class="my-cluster medium-cluster-colors" style="float:left;">
                <div>
                    <span></span>
                </div>
            </div>
            <div class="my-cluster large-cluster-colors" style="float:left;">
                <div>
                    <span></span>
                </div>
            </div>
            <br /><br /><!-- TODO -->
        </div>
        <div class="my-2 pb-2 border-bottom" v-for="obj in data.filter(x => x.layerKey == 'coverage')" :key="obj.title">
            <h6>{{obj.title}}</h6>
            <div class="mx-2 is-flex is-flex-direction-column">
                <div class="legend-row" v-for="cat in obj.data" v-bind:key="cat.label">
                    <span class="color-wrapper">
                        <span class="legend-color" :style="{background: cat.color}"></span>
                    </span>
                    <label>{{cat.label}}</label>
                </div>
            </div>
        </div>
        <div class="my-2 pb-2 border-bottom" v-for="obj in data.filter(x => x.layerKey == 'adm')" :key="obj.title">
            <h6>{{obj.title}}</h6>
            <div class="mx-2 is-flex is-flex-direction-column">
                <div class="legend-row" v-for="cat in obj.data" v-bind:key="cat.label">
                    <span class="color-wrapper">
                        <span class="legend-color" :style="{background: cat.color}"></span>
                    </span>
                    <label>{{cat.label}}</label>
                </div>
            </div>
        </div>
        <div class="my-2 pb-2 border-bottom" v-for="obj in data.filter(x => x.layerKey == 'pop')" :key="obj.title">
            <h6>{{obj.title}}</h6>
            <div class="mx-2 is-flex is-flex-direction-column">
            <img src="@/assets/img/cmap-ylorrd-bar.png" style="height: 20px; width: 136px"/>
            </div>
        </div>
    </div>
</template>


<script>
// types = 'color', 'circle-big', 'circle-small'
export default {
    name: 'custom-legend',
    props: {
        data: {
            type: Array,
            default: function () { [] },
            required: true,
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/style/scss/components/legend.scss";

.my-cluster {
    border-radius: 20px;
    display: flex;
    width: 28px;
    height: 28px;

    div {
        width: 18px;
        height: 18px;
        margin-left: 5px;
        margin-top: 5px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.small-cluster-colors {
    background-color: rgba(181, 226, 140, 0.6);

    div {
        background-color: rgba(110, 204, 57, 0.6);
    }
}

.medium-cluster-colors {
    // width: 40px;
    // height: 40px;
    background-color: rgba(241, 211, 87, 0.6);

    div {
        // width: 30px;
        // height: 30px;
        background-color: rgba(240, 194, 12, 0.6);
    }
}

.large-cluster-colors {
    // width: 44px;
    // height: 44px;
    background-color: rgba(253, 156, 115, 0.6);

    div {
        // width: 34px;
        // height: 34px;
        background-color: rgba(241, 128, 23, 0.6);
    }
}
</style>